import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useActivatedIntegration } from '../../../../../../../../hooks/use-activated-integration';

export function useConnectedCrmProvider() {
  const isHubspotConnected = useActivatedIntegration(INTEGRATION_PROVIDERS.hubspot);
  const isSalesforceConnected = useActivatedIntegration(INTEGRATION_PROVIDERS.salesforce);

  if (isHubspotConnected) return INTEGRATION_PROVIDERS.hubspot;
  if (isSalesforceConnected) return INTEGRATION_PROVIDERS.salesforce;
  return null;
}
